import { render, staticRenderFns } from "./AdminInspectBusiness.vue?vue&type=template&id=9db6a4d4&scoped=true&"
import script from "./AdminInspectBusiness.vue?vue&type=script&lang=js&"
export * from "./AdminInspectBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db6a4d4",
  null
  
)

export default component.exports